import { render, staticRenderFns } from "./check-major.vue?vue&type=template&id=e2c8b43a&scoped=true"
import script from "./check-major.vue?vue&type=script&lang=js"
export * from "./check-major.vue?vue&type=script&lang=js"
import style0 from "./check-major.vue?vue&type=style&index=0&id=e2c8b43a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c8b43a",
  null
  
)

export default component.exports